// contact widget
if ($('.juiced-contact-widget_label').html()) {
	$('.juiced-contact-widget_label').on('click', function () {
		$('.juiced-contact-widget').toggleClass('open');
	});
}
